import React, { useState, useEffect } from 'react';
import { Form, Button } from 'antd';
import { SubmitCol } from './styledComponents';
import AddKeyToPhraseForm from './AddKeyToPhraseForm';

const KeyToPhraseDetailPanel = ({
  showSelectedPhrase,
  selectedItem,
  toggleTable,
  setSubmitDisabled,
  k2pMapping,
  selectedItemColumn,
  selectedPhrase,
  submitHandler,
  selectedFields,
  handleCheck,
  treeVisible,
  toggleTreeVisibility,
  submitLoading,
  handleDeleteClick,
  dynamicEndPoints,
  toggleActive,
  loadingTree,
  handleActiveClickChange,
  toActive,
  handleFormValuesChange,
  submitDisabled,
  handleMineDelete,
  deleteModal,
  updatedK2pMappingkeys,
  handleActivateToggleSave,
  templateMappingModified
}) => {
  const [form] = Form.useForm();
  const [activeEnable, setActiveEnable] = useState(
    selectedItem ? selectedItem.active : true
  );

  useEffect(() => {
    if (showSelectedPhrase && selectedItem === null) {
      form.resetFields();
      setActiveEnable(true);
    }
  }, [showSelectedPhrase, selectedItem]);

  const nonEditableModified =
    !!selectedItem &&
    (activeEnable !== !!selectedItem.active ||
      treeVisible !== !!selectedItem.restrictedToTemplates ||
      templateMappingModified);

  const renderActionButtons = () => {
    if (selectedItem === null) {
      return (
        <Button
          type='primary'
          shape='round'
          loading={submitLoading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      );
    }
    if (selectedItemColumn === 'Active') {
      return (
        <>
          <Button shape='round' danger onClick={handleMineDelete}>
            Delete
          </Button>
          {selectedItem.editable ? (
            <Button
              type='primary'
              shape='round'
              disabled={!submitDisabled}
              loading={submitLoading}
              onClick={() => form.submit()}
            >
              Submit
            </Button>
          ) : (
            <Button
              type='primary'
              shape='round'
              disabled={!nonEditableModified}
              loading={submitLoading}
              onClick={() => handleActivateToggleSave(activeEnable)}
            >
              Submit
            </Button>
          )}
        </>
      );
    }
    if (selectedItemColumn === 'Mine') {
      return (
        <>
          <Button shape='round' danger onClick={handleMineDelete}>
            Delete
          </Button>
          {selectedItem.editable ? (
            <Button
              type='primary'
              shape='round'
              disabled={!submitDisabled}
              loading={submitLoading}
              onClick={() => form.submit()}
            >
              Submit
            </Button>
          ) : (
            <Button
              type='primary'
              shape='round'
              disabled={!nonEditableModified}
              loading={submitLoading}
              onClick={() => handleActivateToggleSave(activeEnable)}
            >
              Submit
            </Button>
          )}
        </>
      );
    }
    return null;
  };

  return (
    <SubmitCol
      bordered={false}
      style={{
        height: '100%',
        backgroundColor: showSelectedPhrase ? '#ffffff' : '#edeff4',
      }}
      bodyStyle={{
        height: '100%',
        boxSizing: 'border-box',
        overflow: 'auto',
        display: showSelectedPhrase ? 'block' : 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {showSelectedPhrase ? (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '12px'
            }}
          >
            <span style={{ fontWeight: 600, fontSize: '16px' }}>
              {selectedItem ? 'Edit Key' : 'Add Key'}
            </span>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {renderActionButtons()}
              <Button shape='round' onClick={toggleTable}>
                Close
              </Button>
            </div>
          </div>
          <AddKeyToPhraseForm
            form={form}
            activeEnable={activeEnable}
            setActiveEnable={setActiveEnable}
            setSubmitDisabled={setSubmitDisabled}
            selectedItem={selectedItem}
            k2pMapping={k2pMapping}
            selectedItemColumn={selectedItemColumn}
            selectedPhrase={selectedPhrase}
            submitHandler={submitHandler}
            selectedFields={selectedFields}
            handleCheck={handleCheck}
            treeVisible={treeVisible}
            toggleTreeVisibility={toggleTreeVisibility}
            submitLoading={submitLoading}
            handleDeleteClick={handleDeleteClick}
            dynamicEndPoints={dynamicEndPoints}
            toggleActive={toggleActive}
            loadingTree={loadingTree}
            handleActiveClickChange={handleActiveClickChange}
            toActive={toActive}
            handleFormValuesChange={handleFormValuesChange}
            submitDisabled={submitDisabled}
            handleMineDelete={handleMineDelete}
            deleteModal={deleteModal}
            updatedK2pMappingkeys={updatedK2pMappingkeys}
            handleActivateToggleSave={handleActivateToggleSave}
            templateMappingModified={templateMappingModified}
          />
        </>
      ) : (
        <p style={{ color: '#8c8c8c' }}>
          Select a key to phrase to view its details
        </p>
      )}
    </SubmitCol>
  );
};

export default KeyToPhraseDetailPanel;
